import { TmApiAccessError } from '@/core/error/transport/tmApiAccessError'

export class TmAuthAccountClosedError extends TmApiAccessError {}
